export default __webpack_public_path__ + "static/media/portable-speaker-3.1143da1b.png";